// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

// @actions
const raErrorHandlerActions = require('./RAErrorHandler');
const brokerMyInvestmentsActions = require('actions/brokerMyInvestments');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const dissociateObjectiveInProgress = () => ({
    type: actionTypes.RA_DISSOCIATE_OBJECTIVE_REQUEST,
});

const dissociateObjectiveSuccess = data => ({
    type: actionTypes.RA_DISSOCIATE_OBJECTIVE_SUCCESS,
    payload: { data },
});

const resetDissociateObjective = () => ({
    type: actionTypes.RA_DISSOCIATE_OBJECTIVE_RESET,
});

const dissociateObjective = (portfolioId, history) => (dispatch, getState) => {
    const params = {
        portfolioId,
    };

    dispatch(dissociateObjectiveInProgress());
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('raDissociateObjective', params),
    )
        .then(response => {
            dispatch(dissociateObjectiveSuccess(response));
            brokerMyInvestmentsActions.outdateMyInvestments()(dispatch);
            brokerMyInvestmentsActions.fetchMyInvestments()(dispatch, getState);
        })
        .catch(error => {
            dispatch(raErrorHandlerActions.show(error, history));
        });
};

module.exports = {
    dissociateObjective,
    resetDissociateObjective,
};
